import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { ColoniaComponent } from "app/features/componentes/index";
import { CotizadorPaqueteList } from "./paquetes/list";
import { ServiciosAdicionalesComp } from "./servadic";
import { Paso } from "./paso";

type Entity = models.CotizadorModel;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    session: models.Session
}

/**
* Componente para editar un Entity
*/
export class CotizacionComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const Colonia = getField(ColoniaComponent);
        const Paquetes = getField(CotizadorPaqueteList);
        const Servicios = getField(ServiciosAdicionalesComp);
        return (
            <div>
                <kea.Title titulo="Cotizador" >
                    <kea.Button onClick={() => this.props.onChange(models.cotizadorInicial)}  >
                        Limpiar
                    </kea.Button>
                </kea.Title>

                <Paso paso={1} title={"Origen y destino"} done={value.IdColoniaDestino != null && value.IdColoniaOrigen != null} />
                {kea.autogrid(6, [
                    <Colonia field="IdColoniaOrigen" label="Origen" iconClass={fa("address-card-o")} />,
                    <Colonia field="IdColoniaDestino" label="Destino" iconClass={fa("map-marker")} />,
                ])}

                <Paso paso={2} title={"Paquetes y sobres"} done={value.Sobres > 0 || value.Paquetes.length > 0} />

                {kea.autogrid(6, [
                    <Paquetes field="Paquetes" />,
                    <Number field="Sobres" label="Cantidad de sobres" />,
                ])}

                {kea.autogrid(6, [
                    <Servicios field="ServiciosAdicionales" />
                ])}

            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cotizador/component.tsx